export default __webpack_public_path__ + "static/media/gps.e5b0be29.svg";